export class UsuarioAeroplanta {
    id: string;
    codigoAeroplanta: string;
    nombre: string;
    validada: boolean;
    ciudadId: string;
    provinciaId: string;
    soloPAD: boolean;
    habilitarFacturacion: boolean;
}